import { IncidentTypeOption } from "@/graphql/generated"
import { SmallInfoCard } from "./SmallInfoCard"
import faultIcon from '@/assets/incidents-icons/fault-icon.svg'
import maintenanceIcon from '@/assets/incidents-icons/maintenance-icon.svg'
import { useUserLanguage } from "@/customHooks"

type IncidentTypeMapperWithIconProps = {
  typeOption: IncidentTypeOption
}

const textsData = {
  en: {
    faultCard: {
      title: 'Type',
      value: 'Fault',
    },
    maintenanceCard: {
      title: 'Type',
      value: 'Maintenance',
    },
  },
  es: {
    faultCard: {
      title: 'Tipo',
      value: 'Falla',
    },
    maintenanceCard: {
      title: 'Tipo',
      value: 'Mantenimiento',
    },
  }
}

export const IncidentTypeMapperWithIcon = ({ typeOption }: IncidentTypeMapperWithIconProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  switch (typeOption) {
    case IncidentTypeOption.Fault:
      return (
        <SmallInfoCard
          icon={faultIcon}
          title={texts.faultCard.title}
          value={texts.faultCard.value}
        />
      )
    
    case IncidentTypeOption.Maintenance:
      return (
        <SmallInfoCard
          icon={maintenanceIcon}
          title={texts.maintenanceCard.title}
          value={texts.maintenanceCard.value}
        />
      )

    default:
      return null
  }
}